'use strict';

const libPictView = require('pict-view');

/**
 * CertificationTypes — the #/CertificationTypes management screen. A left rail lists certification TYPES; the main
 * pane edits the type definition (Name/Hash/Verb/Description) and its per-type configuration (which entity kinds it
 * certifies + certifies-for + default validity). All logic + data live in CertificationTypesProvider, which assigns
 * hand-built HTML into #CertTypes-Rail / #CertTypes-Detail (no widgets — plain inputs + checkboxes).
 */
class CertificationTypes extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.CertificationTypes; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading) { tmpProvider.loadAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = CertificationTypes;
module.exports.default_configuration =
{
	ViewIdentifier: 'CertificationTypes',
	DefaultRenderable: 'CertificationTypesWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.ctp-wrap { padding: 1.25rem 1.5rem 2rem; }
		.ctp-head { margin: 0 0 1rem; }
		.ctp-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.ctp-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; }
		.ctp-cols { display:grid; grid-template-columns: 18rem 1fr; gap:1.1rem; align-items:start; }
		@media (max-width: 860px) { .ctp-cols { grid-template-columns: 1fr; } }
		.ctp-rail { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:0.6rem; max-height:44rem; display:flex; flex-direction:column; }
		.ctp-rail-search { flex:0 0 auto; width:100%; box-sizing:border-box; font-size:0.86rem; padding:0.45rem 0.6rem; margin:0 0 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:7px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.ctp-newtype-btn { flex:0 0 auto; width:100%; box-sizing:border-box; font-size:0.82rem; font-weight:600; padding:0.4rem 0.6rem; margin:0 0 0.55rem; border:1px dashed var(--theme-color-border-medium,#c7cfda); border-radius:7px; background:transparent; color:var(--theme-color-brand-primary,#2e7d74); cursor:pointer; }
		.ctp-newtype-btn:hover { background:var(--theme-color-background-secondary,#eef1f6); }
		.ctp-rail-list { flex:1 1 auto; min-height:0; overflow:auto; }
		.ctp-rail-item { padding:0.45rem 0.55rem; border-radius:6px; cursor:pointer; }
		.ctp-rail-item:hover { background:var(--theme-color-background-secondary,#eef1f6); }
		.ctp-rail-item.is-active { background:var(--theme-color-brand-primary,#2e7d74); }
		.ctp-rail-item.is-active .ctp-rail-name, .ctp-rail-item.is-active .ctp-rail-sub { color:#fff; }
		.ctp-rail-name { font-size:0.9rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); }
		.ctp-rail-sub { font-size:0.76rem; color:var(--theme-color-text-muted,#8894a4); margin-top:0.1rem; }
		.ctp-empty, .ctp-detail-empty { font-size:0.85rem; color:var(--theme-color-text-muted,#8894a4); padding:0.5rem 0.55rem; }
		.ctp-main, .ctp-detail-empty { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; min-height:22rem; }
		.ctp-detail-empty { display:flex; align-items:center; justify-content:center; text-align:center; }
		.ctp-detail-head { margin:0 0 1rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); padding-bottom:0.7rem; position:relative; }
		.ctp-detail-title { font-size:1.2rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); }
		.ctp-detail-sub { font-size:0.8rem; color:var(--theme-color-text-muted,#6b7686); margin-top:0.15rem; }
		.ctp-go { position:absolute; top:0; right:0; }
		.ctp-section { margin:0 0 1.3rem; }
		.ctp-section-head { font-size:0.7rem; font-weight:800; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.5rem; }
		.ctp-note { font-size:0.82rem; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.7rem; }
		.ctp-hint { font-size:0.8rem; color:var(--theme-color-status-warning,#8a6d1b); background:var(--theme-color-status-warning-bg,#fbf3d9); border-radius:6px; padding:0.4rem 0.6rem; margin:0 0 0.7rem; }
		.ctp-field { display:flex; flex-direction:column; gap:0.2rem; font-size:0.72rem; font-weight:600; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.6rem; }
		.ctp-field input, .ctp-field textarea { font-size:0.9rem; font-weight:400; padding:0.4rem 0.55rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); max-width:34rem; }
		.ctp-field-inline { flex-direction:row; align-items:center; gap:0.6rem; flex-wrap:wrap; }
		.ctp-field-inline input { max-width:6rem; }
		.ctp-hint-inline { font-size:0.72rem; font-weight:400; color:var(--theme-color-text-muted,#8894a4); }
		.ctp-cfg-group { margin:0 0 0.9rem; }
		.ctp-cfg-head { font-size:0.72rem; font-weight:700; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.35rem; }
		.ctp-checks { display:flex; flex-wrap:wrap; gap:0.3rem 1rem; }
		.ctp-check { display:inline-flex; align-items:center; gap:0.35rem; font-size:0.85rem; color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
		.ctp-add-row { display:flex; align-items:center; gap:0.5rem; margin:0.5rem 0 0; }
		.ctp-btn { font-size:0.82rem; font-weight:600; padding:0.4rem 0.85rem; border-radius:7px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
		.ctp-btn-primary { color:#fff; background:var(--theme-color-primary,#2f6fed); border-color:var(--theme-color-primary,#2f6fed); }
		.ctp-btn-ghost { background:transparent; }
		.ctp-btn-danger { color:#fff; background:var(--theme-color-status-danger,#c0392b); border-color:var(--theme-color-status-danger,#c0392b); }
		.ctp-btn-danger-link { color:var(--theme-color-status-danger,#c0392b); border:none; background:transparent; padding:0.3rem 0; }
		.ctp-danger { border-top:1px solid var(--theme-color-border-light,#eef1f6); padding-top:0.8rem; }
		.ctp-busy { font-size:0.8rem; color:var(--theme-color-primary,#2f6fed); font-weight:600; }
		.ctp-notice { font-size:0.85rem; color:#276749; background:var(--theme-color-status-success-bg,#e6f4ea); border-radius:6px; padding:0.45rem 0.6rem; margin:0.6rem 0 0; }
		.ctp-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); margin:0.5rem 0 0; }
		.ctp-suggest-btn { color:var(--theme-color-primary,#2f6fed); border-color:var(--theme-color-primary,#2f6fed); }
		.ctp-suggest-list { display:flex; flex-direction:column; gap:0.6rem; margin:0.2rem 0 0.9rem; }
		.ctp-suggest { display:flex; align-items:center; gap:0.8rem; border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; padding:0.7rem 0.85rem; background:var(--theme-color-background-secondary,#f7f9fc); }
		.ctp-suggest-main { flex:1 1 auto; min-width:0; }
		.ctp-suggest-name { font-size:0.95rem; font-weight:700; color:var(--theme-color-text-primary,#1f2733); }
		.ctp-suggest-desc { font-size:0.82rem; color:var(--theme-color-text-secondary,#45505f); margin:0.15rem 0 0; }
		.ctp-suggest-meta { font-size:0.72rem; color:var(--theme-color-text-muted,#8894a4); margin:0.3rem 0 0; }
		.ctp-adopt { flex:0 0 auto; }
	`,
	Templates:
	[
		{
			Hash: 'CertificationTypes-Wrap',
			Template: /*html*/`
				<div class="ctp-wrap">
					<div class="ctp-head">
						<h1 class="ctp-title">Certification Types</h1>
						<p class="ctp-subtitle">Create and edit certification types, and configure what each one certifies (users, labs, materials, equipment, tests) and certifies-for. That configuration drives a simplified certifying screen.</p>
					</div>
					<div class="ctp-cols">
						<div id="CertTypes-Rail" class="ctp-rail"></div>
						<div id="CertTypes-Detail" class="ctp-main"></div>
					</div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'CertificationTypesWrap',
			TemplateHash: 'CertificationTypes-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};
